import gql from 'graphql-tag';

export const getDeviceLogs = gql`
  query ($deviceId: Int) {
    getDeviceLogs (deviceId: $deviceId) {
       temperature
	     humidity
	     status
       height
	     battery
	     live
       error
    }
  }
`
